import { AccordionChevron, NavLink, NavLinkProps } from "@mantine/core"
import {
  NavigateOptions,
  useMatchRoute,
  useNavigate,
} from "@tanstack/react-router"
import { useDisclosure } from "@mantine/hooks"

interface Props extends NavLinkProps {
  navigateOptions?: NavigateOptions
  initiallyOpened?: boolean
  onClick?: (evt: React.MouseEvent<HTMLAnchorElement>) => void
  disableLink?: boolean
}

export function StyledNavlink({
  navigateOptions,
  initiallyOpened,
  disableLink,
  ...props
}: Props) {
  const navigate = useNavigate()
  const matchRoute = useMatchRoute()
  const routeMatched = Boolean(matchRoute({ ...navigateOptions, fuzzy: true }))
  const [opened, handlers] = useDisclosure(
    initiallyOpened || routeMatched || false
  )

  return (
    <NavLink
      h="3rem"
      {...props}
      onClick={(evt) => {
        if (disableLink) {
          handlers.toggle()
        } else {
          props.onClick && props.onClick(evt)
          navigateOptions && navigate(navigateOptions)
        }
      }}
      rightSection={
        <>
          {props.rightSection}
          {props.children ? (
            <AccordionChevron
              style={{ rotate: "-90deg" }}
              onClick={(e) => {
                e.stopPropagation()
                handlers.toggle()
              }}
            />
          ) : null}
        </>
      }
      opened={opened}
      active={!disableLink && routeMatched}
    />
  )
}
